import { connect } from 'react-redux';
import YourUsage from './YourUsage';
import { updateUsageDisplayMode } from '../../actions/usage';
import { initNewOffer } from '../../modules/NewOffer/actions';
import {
  currentSubscriptionSelector,
  canChangePlanOrOptionsOfCurrentSubscriptionSelector,
} from '../../modules/Dashboard';
import { usagesSelector } from '../../modules/Usage/selectors';
import { goToInternationalTopUpOfZone } from '../../modules/International/IDD';
import { selectUsage } from '../../modules/Usage/actions';
import { isEmpty } from 'lodash';
import { currentSubscriptionPaymentAuthenticationsSelector } from '../../modules/Payment/selector';

function mapStateToProps(state) {
  const usages = usagesSelector(state);
  const activeUsage = isEmpty(state.usage?.currentUsage) ? usages[0] : state.usage.currentUsage;
  const usageGraphDisplayMode = state.usage.displayMode;

  return {
    hasUnauthenticatedPayment: !!currentSubscriptionPaymentAuthenticationsSelector(state).length,
    usages,
    activeUsage,
    usageGraphDisplayMode,
    subscription: currentSubscriptionSelector(state),
    canBoostPlan: canChangePlanOrOptionsOfCurrentSubscriptionSelector(state),
  };
}

const mapDispatchToProps = {
  onUsagePress: selectUsage,
  updateUsageDisplayMode: updateUsageDisplayMode,
  goToInternationalTopUpOfZone,
  changePlan: subscription =>
    initNewOffer({
      plan: subscription.plan,
      options: subscription.options,
      price: subscription.price,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(YourUsage);
